:host {
  --size: 16px;
  --font-size: 14px;
  --font-weight: 400;
  --border-radius: calc(var(--size)* .125);
  --transition: background 180ms cubic-bezier(0.4, 0, 0.2, 1);
  --border-width: 2px;
  --border-style: solid;
  --disabled-color: rgba(0,0,0,0.25);
  --border-color-unchecked: #333333;
  --border-color-checked: #fd5000;
  --checkbox-background-checked: #fd5000;
  --checkbox-background: #ffffff;

  display: block;
  position: relative;
  cursor: pointer;
  user-select: none;
  z-index: 2;
}

.label-text-wrapper {
  font-size: var(--font-size);
  line-height: var(--size);
  color: var(--border-color-unchecked);
  font-weight: var(--font-weight);
}

.label-text-wrapper-hidden {
  display: none;
}

input {
  position: absolute;
  inset: 0px;
  width: 100%;
  height: 100%;
  margin: 0px;
  padding: 0px;
  border: 0px;
  outline: 0px;
  clip: rect(0px, 0px, 0px, 0px);
  opacity: 0;
  overflow: hidden;
  appearance: none;
}

.native-wrapper {
  display: flex;
  align-items: center;
}

.checkbox-icon {
  position: relative;
  width: var(--size);
  height: var(--size);
  border-radius: var(--border-radius);
  transition: var(--transition);
  border-width: var(--border-width);
  border-style: var(--border-style);
  border-color: var(--border-color-unchecked);
  box-sizing: border-box;
  background: var(--checkbox-background);
}

.checkbox-icon path {
  fill: none;
  stroke: #ffffff;
  stroke-width: 3;
  opacity: 0;
  stroke-dasharray: 30;
  stroke-dashoffset: 30;
}

.checkbox-wrapper {
  display: flex;
  flex-grow: 1;
  align-items: flex-start;
  height: inherit;
  cursor: inherit;
  gap: 4px;
}


/* 位置 */
:host(.checkbox-label-placement-start) .checkbox-wrapper, :host(.checkbox-label-placement-fixed) .checkbox-wrapper {
  flex-direction: row-reverse;
  justify-content: flex-end;
}
:host(.checkbox-label-placement-fixed) .checkbox-wrapper .label-text-wrapper {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
:host(.checkbox-label-placement-end) .checkbox-wrapper {
  flex-direction: row;
  justify-content: flex-start;
}
:host(.checkbox-label-alignment-center) .checkbox-wrapper {
  align-items: center;
}
/* 位置 */

/* checkbox 选中状态 */
:host(.checkbox-checked) .checkbox-icon {
  border-color: var(--border-color-checked);
  background: var(--checkbox-background-checked);
}
:host(.checkbox-checked) .checkbox-icon path {
  opacity: 1;
  stroke-dashoffset: 0;
  transition: stroke-dashoffset 90ms linear 90ms;
}
/* checkbox 选中状态 */

/* 禁用状态 */
:host(.checkbox-disabled) {
  pointer-events: none;
}
:host(.checkbox-disabled) .label-text-wrapper {
  color: var(--disabled-color);
}
:host(.checkbox-disabled) .checkbox-icon {
  border-color: var(--disabled-color);
}
/* 禁用状态 */